<template>
  <v-main>
    <!-- Provides the application the proper gutter -->
    <v-container fluid>
      <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>

      <!-- If using vue-router -->
      <!-- <router-view></router-view> -->
      <v-card>
        <v-card-title>
          Medical Check Up
          <v-spacer></v-spacer>

          <v-btn color="purple" dark class="mb-2" @click="doAdd">
            Tambah
          </v-btn>

          <v-dialog v-model="dialog" persistent max-width="600px">
            <v-card>
              <v-card-title>
                <span class="text-h5">Medical Check Up</span>
              </v-card-title>
              <v-card-text>
                <v-form
                  ref="form"
                  v-model="valid"
                  lazy-validation
                  class="pl-4 pr-4"
                >
                  <v-container>
                    <v-row>
                      <v-col cols="12">
                        <v-text-field
                          v-model="currentData.nama"
                          label="Nama"
                          required
                          :rules="currentData.namaRules"
                        ></v-text-field>
                        <v-text-field
                          v-model="currentData.nama_en"
                          label="Nama Inggris"
                          required
                          :rules="currentData.namaRules"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12">
                        <v-text-field
                          v-model="currentData.phone"
                          label="No Whatsapp"
                          required
                          :rules="currentData.phoneRules"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="12" md="12">
                        <v-file-input
                          v-model="currentData.foto_url"
                          accept="image/*"
                          prepend-icon="mdi-image"
                          show-size
                          label="Foto"
                          @change="loadImage"
                        />
                      </v-col>
                      <v-col cols="12" sm="12" md="12">
                        <v-responsive :aspect-ratio="16 / 9">
                          <v-img
                            :key="currentData.fotoKey"
                            :src="currentData.FotoUrl"
                            contain
                          ></v-img>
                        </v-responsive>
                      </v-col>
                      <v-col cols="12" sm="12" md="12">
                        <v-file-input
                          v-model="currentData.icon_url"
                          accept="image/*"
                          prepend-icon="mdi-image"
                          show-size
                          label="Icon"
                          @change="loadIcon"
                        />
                      </v-col>
                      <v-col cols="12" sm="12" md="12">
                        <v-responsive :aspect-ratio="16 / 9">
                          <v-img
                            :key="currentData.iconKey"
                            :src="currentData.IconUrl"
                            contain
                          ></v-img>
                        </v-responsive>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="dialog = false">
                  Close
                </v-btn>
                <v-btn color="blue darken-1" text @click="doSave"> Save </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-dialog v-model="dialogDelete" max-width="500px">
            <v-card>
              <v-card-title class="text-h5"
                >Apa anda akan menghapus data ini?</v-card-title
              >
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="closeDelete"
                  >Tidak</v-btn
                >
                <v-btn color="blue darken-1" text @click="deleteItemConfirm"
                  >Ya</v-btn
                >
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-card-title>

        <v-row class="mx-4 my-4">
          <v-col cols="12" sm="4" md="4">
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Cari Nama"
              single-line
              outlined
              dense
              hide-details
              @keyup.enter="getDataFromApi"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-data-table
          v-model="selected"
          :headers="headers"
          :items="list_data"
          :options.sync="options"
          :server-items-length="totalData"
          :loading="loading"
          class="elevation-1"
          :single-select="true"
          show-select
        >
          <template #[`item.icon`]="{ item }">
            <v-img :src="item.icon" contain width="100"></v-img>
          </template>

          <template #[`item.photo`]="{ item }">
            <v-img :src="item.photo" contain width="100"></v-img>
          </template>

          <template #[`item.actions`]="{ item }">
            <v-icon medium class="mr-3" @click="editItem(item)">
              mdi-pencil
            </v-icon>
            <v-icon medium @click="deleteItem(item)"> mdi-delete </v-icon>
          </template>
          <template #[`item.foto_url`]="{ item }">
            <v-responsive v-if="item.foto_url_original">
              <v-img :src="item.foto_url" contain width="100"></v-img>
            </v-responsive>
          </template>
        </v-data-table>
      </v-card>

      <v-card class="mt-4">
        <McuLayananComponent
          v-if="selected != undefined && selected.length > 0"
          :id="selected[0].id"
          ref="mychild"
          :key="childKey"
        />
      </v-card>
    </v-container>
  </v-main>
</template>

<script>
import McuService from "../../services/master/McuService";
import CommonService from "../../services/CommonService";

import McuLayananComponent from "./McuLayanan.vue";

export default {
  components: {
    McuLayananComponent,
  },
  data: () => ({
    valid: true,
    childKey: 0,
    selected: [],
    breadcrumbs: [
      {
        text: "Data Medical Check Up",
        disabled: true,
        href: "breadcrumbs_dashboard",
      },
    ],
    search: "",
    headers: [
      {
        text: "No",
        align: "start",
        sortable: false,
        value: "no",
      },
      { text: "Nama", value: "nama", sortable: false },
      { text: "No Whatsapp", value: "phone", sortable: false },
      { text: "Icon", value: "icon", sortable: false },
      { text: "Foto", value: "photo", sortable: false },
      { text: "Actions", value: "actions", sortable: false },
    ],
    isFirst: false,
    totalData: 0,
    list_data: [],
    loading: true,
    options: {
      itemsPerPage: 10,
    },

    editedIndex: -1,
    editedItem: {},
    dialog: false,
    dialogDelete: false,

    currentData: {
      id: null,
      nama: "",
      nama_en: "",
      phone: "",
      foto_url: null,
      icon_url: null,
      fileKey: 0,
      FotoUrl: "",
      IconUrl: "",
      fotoKey: 0,
      iconKey: 0,
      namaRules: [(v) => !!v || "Nama harus diisi"],
    },
  }),
  watch: {
    selected: {
      handler() {
        if (this.selected != undefined && this.selected[0]) {
          this.childKey++;
        }
      },
      deep: true,
    },
    options: {
      handler() {
        if (this.isFirst) {
          this.getDataFromApi();
        }
      },
      deep: true,
    },
  },
  mounted() {
    this.getDataFromApi();
  },
  methods: {
    loadImage: function (data) {
      console.log("loadImage:", data);
      if (data) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.currentData.FotoUrl = e.target.result;
          this.currentData.fotoKey++;
        };
        reader.readAsDataURL(data);
      } else {
        this.currentData.FotoUrl = "";
        this.currentData.foto_url = null;
      }
    },

    loadIcon: function (data) {
      if (data) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.currentData.IconUrl = e.target.result;
          this.currentData.iconKey++;
        };
        reader.readAsDataURL(data);
      } else {
        this.currentData.IconUrl = "";
        this.currentData.icon_url = null;
      }
    },

    getDataFromApi() {
      const { page, itemsPerPage } = this.options;

      this.loading = true;
      McuService.mcuList(page, itemsPerPage, this.search)
        .then((res) => {
          this.list_data = res.data.list_data;
          this.totalData = res.data.total;
          this.loading = false;
          this.isFirst = true;
        })
        .catch((err) => {
          this.loading = false;
          this.isFirst = true;
          console.log(err);
        });
    },

    doAdd: async function () {
      this.dialog = true;
      this.currentData.id = null;
      this.currentData.nama = "";
      this.currentData.nama_en = "";
      this.currentData.phone = "";
      this.currentData.foto_url = null;
      this.currentData.FotoUrl = null;

      this.currentData.icon_url = null;
      this.currentData.IconUrl = null;
    },

    doSave: async function () {
      if (!this.$refs.form.validate()) {
        window.scrollTo(0, 0);
        return;
      }

      if (this.currentData.id != null) {
        McuService.update(this.currentData)
          .then((res) => {
            console.log(res);
            this.dialog = false;
            CommonService.showSuccessToast("Update mcu berhasil");

            this.getDataFromApi();
          })
          .catch((err) => {
            console.log(err);
            CommonService.showErrorToast("Update mcu gagal. Coba lagi");
          });
      } else {
        McuService.create(this.currentData)
          .then((res) => {
            console.log(res);
            this.dialog = false;
            CommonService.showSuccessToast("Tambah mcu berhasil");

            this.getDataFromApi();
          })
          .catch((err) => {
            console.log(err);
            CommonService.showErrorToast("Tambah mcu gagal. Coba lagi");
          });
      }
    },

    editItem(item) {
      console.log(item);
      this.editedIndex = this.list_data.indexOf(item);
      this.editedItem = Object.assign({}, item);

      this.dialog = true;
      this.currentData.nama = this.editedItem.nama;
      this.currentData.nama_en = this.editedItem.nama_en;
      this.currentData.phone = this.editedItem.phone;
      this.currentData.FotoUrl = this.editedItem.photo;
      this.currentData.IconUrl = this.editedItem.icon;
      this.currentData.id = this.editedItem.id;
      this.currentData.fotoKey++;
    },

    deleteItem(item) {
      console.log(item);
      this.editedIndex = this.list_data.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },

    deleteItemConfirm() {
      this.closeDelete();

      McuService.delete(this.editedItem.id)
        .then((res) => {
          console.log(res);
          CommonService.showSuccessToast("Hapus mcu berhasil");

          this.getDataFromApi();
        })
        .catch((err) => {
          console.log(err);

          CommonService.showErrorToast("Hapus mcu gagal. Coba lagi");
        });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
  },
};
</script>
